





































import Vue from "vue";
import Lottie from "vue-lottie";
import ChallengeVoiceGuidance from "./ChallengeVoiceGuidance.vue";
import * as help1 from "@/assets/lottie/help1.json";
import * as help2 from "@/assets/lottie/help2.json";
import { ChallengeDetails } from "@/js/RemoteStarter";
import { ChallengeProcessor } from "@/js/ChallengeProcessor";
import { RemoteVerifier } from "@/js/RemoteVerifier";
import { Utils } from "@/js/Utils";

export default Vue.extend({
  name: "Challenge",
  components: {
    Lottie,
    ChallengeVoiceGuidance
  },
  props: {
    details: Object
  },
  data() {
    return {
      messageKey: "loading",
      animation: -1,
      // @ts-ignore
      lottieOptions1: { animationData: help1.default },
      // @ts-ignore
      lottieOptions2: { animationData: help2.default },
      countdown: 0,
      countdownInterval: null,
      challengeProcessor: null as ChallengeProcessor | null,
      showCountdown: false,

      videoWidth: Utils.getMediaStreamInfo().actualWidth,
      videoHeight: Utils.getMediaStreamInfo().actualHeight,
      shouldRotate: Utils.getConfigBooleanValue("FLIP_VIDEO"),
      // Ugly hack to pass variables to CSS
      cssVars: {
        "--video-width": Utils.getMediaStreamInfo().actualWidth + "px",
        "--video-height": Utils.getMediaStreamInfo().actualHeight + "px",
        "--help-container-padding-top": Utils.getMediaStreamInfo().actualHeight + 5 + "px",
        "--video-transform": `scale(${Utils.getMediaStreamInfo().elementScale})`
      }
    };
  },
  computed: {
    voiceStep() {
      switch (this.animation) {
        case 1:
          if (this.messageKey === "challenge.messages.faceIsNotInCenter") return "step_area";
          return "face_too_large";
        case 2:
          return "step_nose";
        case 3:
          return "step_face_up";
        default:
          return "";
      }
    },
    message(): string {
      if (!this.messageKey) return "";
      return this.$tc(this.messageKey);
    }
  },
  methods: {
    onLocalEnd(success: boolean, remoteVerifier: RemoteVerifier | undefined): void {
      if (success) {
        this.$emit("local-success", remoteVerifier as RemoteVerifier);
      } else {
        this.$emit("local-fail");
      }
    },
    onHelpMessage(messageKey: string | undefined): void {
      if (messageKey) {
        this.messageKey = messageKey;
        if (
          messageKey === "challenge.messages.moveNoseRequestMessage" ||
          messageKey === "challenge.messages.faceUpRequestMessage"
        ) {
          this.startCountdown();
        }
      } else {
        this.messageKey = "";
      }
    },
    onHelpAnimation(animationNumber: number | undefined): void {
      this.animation = animationNumber || -1;
    },
    decreaseCountdown(): void {
      this.countdown--;
      if (this.countdown <= 0) {
        this.stopCountdown();
      }
    },
    stopCountdown(): void {
      clearInterval(this.countdownInterval as any);
      this.showCountdown = false;
    },
    startCountdown(): void {
      this.showCountdown = true;
      this.countdown = parseInt(Utils.getConfig().STATE_NOSE_DURATION_IN_SECONDS);
      this.countdownInterval = setInterval(this.decreaseCountdown.bind(this), 1000) as any;
    }
  },
  mounted: function() {
    const self: any = this;
    this.$nextTick(function() {
      self.challengeProcessor = new ChallengeProcessor(
        self.details as ChallengeDetails,
        "webcamVideo",
        "overlayCanvas",
        self.onLocalEnd,
        self.onHelpMessage,
        self.onHelpAnimation
      );
    });
  },
  beforeDestroy: function() {
    const challengeProcessor: ChallengeProcessor | null = this.challengeProcessor;
    if (challengeProcessor) challengeProcessor.flagAsStop();
  }
});
